/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      //console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    //console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //   document.addEventListener('theme:scroll', e => { console.log(e); });
  //   document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //   document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //   document.addEventListener('theme:resize', e => { console.log(e); });

  const classes$c = {
    loading: 'loading',
    success: 'has-success',
  };

  function updateHeaderTotal() {
    axios
    .get(`${window.theme.routes.cart}.js`)
    .then((response) => {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          detail: {
            cart: response.data,
          },
          bubbles: true,
        })
      );

      //       document.dispatchEvent(
      //         new CustomEvent('theme:drawer:open', {
      //           bubbles: true,
      //         })
      //       );

      $(document).find('[data-drawer-toggle="drawer-cart"]').trigger('click');


    })
    .catch((e) => {
      console.error(e);
    });
  }

  $(document).on('click','[data-add-to-cart-variant]',function(e){
    e.preventDefault();
    var form = $(this).closest('form'),
        formd = form.serialize();
    var button = $(this);
    button.attr('disabled', true);
    button.addClass(classes$c.loading);
    setTimeout(function(){
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: formd,
        dataType: 'json',
        success: function(cart){
          button.removeAttr('disabled');
          button.removeClass(classes$c.loading);
          updateHeaderTotal()
        },
        error :function(data,responseText,responseJSON){
          let text = 'Network error: please try again';

          if (data && data.responseJSON.description) {
            console.log('if')
            text = data.responseJSON.description;
          }
          const errorsHTML = `<div class="errors">${text}</div>`;

          button.removeAttr('disabled');
          button.removeClass(classes$c.loading);
          $(document).find('[data-form-errors]').html(errorsHTML).show();

        }
      });
    },200)
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
